/**
 * gives equal height to every instance.
 */
WW.allEqualHeights = function($) {
    'use strict';

    equalHeight($('.js-all-equal-height'));

    function equalHeight(collection) {
        let tallest = 0;
        [].forEach.call(collection, function(el) {
            const height = $(el).height();
            height > tallest ? tallest = height : tallest;
        });
        $(collection).height(tallest);
    }

    return this;
};